import React from 'react';
import { NavBar, Icon } from 'antd-mobile';
import { useHistory } from 'react-router';
import { getBooleanValue } from '@/utils';
import './index.scss'

const ManageBar = (props) => {

    const { title, children, transparent, back } = props;

    const history = useHistory();

    return (
    <div className="manage">
        {
            !window.ext3bu &&
            <NavBar
                mode="light"
                icon={<Icon type="left" className="bar-left" />}
                onLeftClick={() => back ? back(): history.go(-1)}
                style={getBooleanValue('IS_IMMERSE', false) ? { paddingTop: '6vw', height: '18vw' } : null}
            >
                {title}
            </NavBar>
        }
        <div className={`container ${transparent && 'background-transparent'}`}>
            { children }
        </div>
    </div>
    )
}

export default ManageBar